import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const orgTypeEnums = ['gap', 'advisor', 'client'] as const

export const OrgTypeEnumSchema = z.enum(orgTypeEnums, { errorMap })
export type OrgTypeEnum = z.output<typeof OrgTypeEnumSchema>
